import style from "./index.module.scss";
import ContentBox from "./components/content";
import CloseIcon from "@mui/icons-material/Close";
import { DialogTitle, IconButton, DialogContent } from "@mui/material";
import { useState, useEffect } from "react";
import UKDialog from "@/components/UKDialog";
import { useTranslation } from "@/i18n/client";

interface PersonalInfoSetProps {
  open: boolean;
  onlyClose?: () => void;
  onSaver?: () => void;
}

const InfoSettingDialog = (props: PersonalInfoSetProps) => {
  const { t } = useTranslation(); 
  const { open, onlyClose, onSaver } = props;
  const [isOpen, setIsOpen] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  // 关闭弹框
  const handleClose = () => {
    setIsOpen(false);
    onlyClose && onlyClose();
  };
  const saverSuccessFn = () => {
    window.JDIheader && window.JDIheader.initUserInfo();
    setIsOpen(false);
    onSaver && onSaver();
  };

  return (
    <UKDialog
      open={isOpen}
      className={style.orderErrorPage}
      showCloseBtn={false}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-paper": {
          width: "440px", // 设置自定义宽度
          minHeight: "476px",
          maxHeight: "676px",
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {t('settings.editProfile')}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent dividers sx={{ borderBottomColor: "#00000000", borderTopColor: "#00000000" }}>
        <ContentBox onContentClose={handleClose} saverSuccessFn={saverSuccessFn} />
      </DialogContent>
    </UKDialog>
  );
};

export default InfoSettingDialog;
